const translations = {
  ar: {
    dashboard:      'لوحة التحكم',
    reports:        'التقارير',
    settings:       'الإعدادات',
    logout:         'تسجيل الخروج',
    students:       'الطلاب',
    addStudent:     'إضافة طالب',
    viewDetails:    'عرض التفاصيل',
    totalSessions:  'إجمالي الجلسات',
    topSubject:     'أعلى مادة',
    weekSessions:   'جلسات هذا الأسبوع',
    familyOverview: 'نظرة عامة على الأسرة',
    noSessionsYet:  'لم تبدأ أي جلسة بعد',
    startNow:       'ابدأ الآن',
    recentReports:  'آخر التقارير',
    noReports:      'لا توجد تقارير بعد',
    noStudents:     'لا يوجد طلاب بعد',
    save:           'حفظ التغييرات',
    cancel:         'إلغاء',
    delete:         'حذف',
    edit:           'تعديل',
    search:         'بحث',
    sendEmail:      'إرسال بالبريد',
    viewReport:     'عرض التقرير',
    close:          'إغلاق',
    loading:        'جاري التحميل...',
    welcome:        'مرحباً',
    overview:       'نظرة عامة',
    grade:          'الصف',
    lastSession:    'آخر جلسة',
    subject:        'المادة',
    subjects:       'مادة',
    viewAll:        'عرض الكل',
    retryBtn:       'إعادة المحاولة',
    all:            'الكل',
    from:           'من',
    to:             'إلى',
    page:           'صفحة',
    of:             'من',
    prev:           '← السابق',
    next:           'التالي →',
    noMatchReports: 'لا توجد تقارير بهذه المعايير',
    accountSettings:'إعدادات الحساب',
    notifSettings:  'إعدادات الإشعارات',
    manageStudents: 'إدارة الطلاب',
    changePassword: 'تغيير كلمة المرور',
    saveNotifs:     'حفظ إعدادات الإشعارات',
    confirmDelete:          'تأكيد الحذف',
    examDates:              'مواعيد الامتحانات',
    midterm:                'امتحان منتصف الترم',
    finalExam:              'امتحان نهاية الترم',
    monthlyTests:           'الاختبارات الشهرية',
    addDate:                '+ إضافة موعد',
    required:               'هذا الحقل مطلوب',
    dateOrderError:         'يجب أن يكون موعد نهاية الترم بعد منتصف الترم',
    monthlyDateRangeError:  'يجب أن يكون الموعد بين منتصف الترم ونهايته',
  },
  en: {
    dashboard:      'Dashboard',
    reports:        'Reports',
    settings:       'Settings',
    logout:         'Logout',
    students:       'Students',
    addStudent:     'Add Student',
    viewDetails:    'View Details',
    totalSessions:  'Total Sessions',
    topSubject:     'Top Subject',
    weekSessions:   "This Week's Sessions",
    familyOverview: 'Family Overview',
    noSessionsYet:  'No sessions started yet',
    startNow:       'Start Now',
    recentReports:  'Recent Reports',
    noReports:      'No reports yet',
    noStudents:     'No students yet',
    save:           'Save Changes',
    cancel:         'Cancel',
    delete:         'Delete',
    edit:           'Edit',
    search:         'Search',
    sendEmail:      'Send by Email',
    viewReport:     'View Report',
    close:          'Close',
    loading:        'Loading...',
    welcome:        'Welcome',
    overview:       'Overview',
    grade:          'Grade',
    lastSession:    'Last session',
    subject:        'Subject',
    subjects:       'subjects',
    viewAll:        'View All',
    retryBtn:       'Retry',
    all:            'All',
    from:           'From',
    to:             'To',
    page:           'Page',
    of:             'of',
    prev:           '← Prev',
    next:           'Next →',
    noMatchReports: 'No reports match these filters',
    accountSettings:'Account Settings',
    notifSettings:  'Notification Settings',
    manageStudents: 'Manage Students',
    changePassword: 'Change Password',
    saveNotifs:     'Save Notification Settings',
    confirmDelete:          'Confirm Delete',
    examDates:              'Exam Dates',
    midterm:                'Mid-Term Exam',
    finalExam:              'Final Exam',
    monthlyTests:           'Monthly Tests',
    addDate:                '+ Add Date',
    required:               'This field is required',
    dateOrderError:         'Final exam must be after mid-term',
    monthlyDateRangeError:  'Date must be between mid-term and final exam',
  },
};

export default translations;
